// extracted by mini-css-extract-plugin
export default {"diffusion":"Messages_diffusion__G1DPl","video-message":"Messages_video-message__5OcEa"};